import NotificationEmptyStateIcon from "@src/assets/icons/NotificationEmptyStateIcon";
import Colors from "@src/constants/Colors";

import {
  NotificationEmptyStateCard,
  NotificationEmptyStateText,
} from "../../Notification/NotificationList/NotificationEmptyState/style";

const SingleCheckEmptyState = () => {
  return (
    <NotificationEmptyStateCard>
      <NotificationEmptyStateIcon />
      <NotificationEmptyStateText
        fontFamilyBold
        color={Colors.neutral_gray_500}
      >
        No Check Available
      </NotificationEmptyStateText>
    </NotificationEmptyStateCard>
  );
};

export default SingleCheckEmptyState;
